<template>
  <div class="portfolio-tracker-options-panel">
    <h3 class="portfolio-tracker-options-panel__heading">{{ heading }}</h3>
    <div
      v-for="(option, index) in options"
      :key="index"
      class="portfolio-tracker-options-panel__option"
    >
      <span class="portfolio-tracker-options-panel__badge">{{ index + 1 }}</span>
      <div class="portfolio-tracker-options-panel__copy">
        <p class="portfolio-tracker-options-panel__title">{{ option.title }}</p>
        <p class="portfolio-tracker-options-panel__description">{{ option.description }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import type { TrackerOption } from '@/components/Senior/PortfolioTracker/content'

// Numbered purchase/return options surfaced in the Portfolio Tracker modal.
// All copy comes in as a resolved array from the parent modal, which owns
// the content + placeholder substitution logic. Badge numbers are
// derived from the array index — adding a 4th option (or trimming to 2) is a
// content-only change. Backing storage in `content.ts` stays flat to align
// with the Contentful KVP pattern (one key per field).
export default defineComponent({
  name: 'PortfolioTrackerOptionsPanel',
  props: {
    heading: { type: String, required: true },
    options: { type: Array as PropType<TrackerOption[]>, required: true }
  }
})
</script>

<style scoped lang="scss">
.portfolio-tracker-options-panel {
  &__heading {
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 1rem;
  }

  &__option {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 1.25rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__badge {
    flex: 0 0 auto;
    width: 1.625rem;
    height: 1.625rem;
    border-radius: 50%;
    background: #bb4a92;
    color: #fff;
    font-weight: 700;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &__copy {
    flex: 1 1 auto;
  }

  &__title {
    font-weight: 700;
    font-size: 1rem;
    margin: 0 0 0.125rem;
  }

  &__description {
    font-size: 1rem;
    margin: 0;
    color: #000;
  }
}
</style>
